export const PaymentAdjustmentTypes = {
  CASH_ROUNDING: "CASH_ROUNDING",
  CARD_SURCHARGE: "CARD_SURCHARGE",
  NONE: "NONE",
} as const

export type PaymentAdjustmentType =
  (typeof PaymentAdjustmentTypes)[keyof typeof PaymentAdjustmentTypes]
